{
  "search_count": "{count} {noun} suchen",
  "nouns": { "used": "Autos", "truck": "Transporter", "motorcycle": "Motorräder" },
  "tabs": { "truck": "Transporter" },
  "search_reassurance": "Keine Provision. Rufen Sie den Verkäufer direkt an.",
  "call": "Anrufen",
  "whatsapp": "WhatsApp",
  "message": "Nachricht senden",
  "unspecified": "Vom Verkäufer nicht angegeben",
  "passenger_total": "Pkw und SUVs",
  "hero_active": "{count} aktive Anzeigen.",
  "hero_direct": "Rufen Sie den Verkäufer direkt an.",
  "trust_active": "{count} aktive Anzeigen",
  "trust_dealers": "{count} geprüfte Händler",
  "trust_commission": "0% Provision für Käufer",
  "sort_label": "Sortieren nach",
  "sort_options": { "newest": "Zuletzt hinzugefügt", "price_asc": "Preis aufsteigend", "price_desc": "Preis absteigend", "year_desc": "Baujahr: neueste zuerst", "mileage_asc": "Kilometerstand aufsteigend" }
}